import { App, View } from '@gin-betting/core';
import { find } from 'lodash';

import { SportEventMetaKey } from 'app-constants';
import { useMemoSelector } from 'hooks';
import { selectOverviewScores } from 'selectors';

interface Input {
    matchId: string;
    text: string | null;
    subText: string | null;
}

interface Output {
    isVar: boolean;
    text: string | null;
    subText: string | null;
}

const useFixtureDataFootball = ({ matchId, text, subText }: Input): Output => {
    const { scores, currentMatchPart, meta } = useMemoSelector(
        selectOverviewScores,
        {
            matchId,
        }
    );

    const isVar = meta.some(item => item.name === SportEventMetaKey.Var);

    if (
        currentMatchPart &&
        currentMatchPart.type === App.MetaTypes.TYPE_PERIOD_PENALTIES
    ) {
        const { home, away } = find(
            scores,
            s => s.type === App.ScoreTypes.TYPE_PERIOD_PENALTIES
        ) as View.ScoreInfo;

        return {
            isVar,
            text: `${text} (${home}:${away})`,
            subText: null,
        };
    }

    return { isVar, text, subText };
};

export default useFixtureDataFootball;
